var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container"},[_c('p',{staticClass:"copyright"},[_vm._v("Copyright © 版权所有 ")])])])
}]

export { render, staticRenderFns }